import { render, staticRenderFns } from "./adminExtend.vue?vue&type=template&id=3b5b94ff&scoped=true&"
import script from "./adminExtend.vue?vue&type=script&lang=js&"
export * from "./adminExtend.vue?vue&type=script&lang=js&"
import style0 from "./adminExtend.vue?vue&type=style&index=0&id=3b5b94ff&scoped=true&lang=css&"
import style1 from "./adminExtend.vue?vue&type=style&index=1&id=3b5b94ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5b94ff",
  null
  
)

export default component.exports